module.exports = __webpack_public_path__ + "static/media/karl_icelandic.9fba8d46.mp3";